import React from 'react'
import '../../styles/services.css'

function ComputingService(){
    return(
        <div className="sub_page_wrapper page_content">
            <h3>Client Computing Management</h3>
            <ol>
                <li>Networking and infrastructure solutions</li>
                <li>Strategic Sourcing and Supply</li>
                <li>Support, monitoring and maintenance</li>
                <li>Email services, collaboration, and website management services</li>
                <li>Server infrastructure implementation and management</li>
                <li>Service desk remote management</li>
            </ol>

            <p>The support team will:</p>
            <p>
                <ul>                    
                    <li> Provide and terminate end user access to the organisational network</li>
                    <li>Provide and maintain access on end user devices</li>
                    <li>Manage the required configurations base on the stipulate organisational ladder</li>
                    <li>Computing imaging of client configuration</li>
                    <li>End to end desk management - software installation, anti-virus, new releases, patches and
                back-office updates. This can be done remotely or physically.</li>
                <li>Asset management -assets audits, tracking and replacements and repair of critical
                components on all end user device types</li>
                <li>Hardware management</li>
                <li>System security (Anti-virus).</li>
                <li>Bring your own device (BYOD) management</li>
                <li>Employee training on end user devices and organisational systems.</li>
                <li>Install, configure and move network points based on business needs.</li>
                <li>Provide remote and onsite first level and secondary support.</li>
                <li>Comprehensive IT reporting and data analytics for decision making. </li>

                </ul>
            </p>
        </div>
    )
}

export default ComputingService;